<template>
  <div class="sb-pagination__per-page-container">
    <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
    <label for="sb-pagination-per-page" class="sb-pagination__per-page-label">
      {{ selectPerPageTranslated }}
    </label>
    <SbPaginationSelect
      input-id="sb-pagination-per-page"
      :options="perPageOptions"
      :model-value="perPage"
      aria-label="Items Per Page"
      labeled-by="sb-pagination-per-page"
      @change="onSelectChange"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { factorySelectOption } from '../utils'
import i18n, { type Locale } from '../../../i18n'
import { SbPaginationSelect } from './shared'

export type SbPerPageContainerProps = {
  perPage?: number
  perPageAvailable?: number[]
  locale?: Locale
}

const props = withDefaults(
  defineProps<SbPerPageContainerProps>(),
  {
    perPage: 1,
    perPageAvailable: () => [],
    locale: 'en',
  },
)

const emit = defineEmits<{
  (e: 'per-page-change', value: number): void
}>()

const selectPerPageTranslated = computed(
  () => i18n(props.locale, 'selectPerPage') + ':',
)

const perPageOptions = computed(() =>
  props.perPageAvailable.map((perPage: number) =>
    factorySelectOption(
      perPage,
      (value: number) =>
        i18n(props.locale, 'selectPerPage') +
        ` ${value} ` +
        i18n(props.locale, 'items'),
    ),
  ),
)

function onSelectChange(value: number) {
  emit('per-page-change', value)
}
</script>
